import * as React from "react";
import { forwardRef } from "react";
const SvgDisabled = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M4 8.5V11.5H16V8.5H4Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgDisabled);
export default ForwardRef;
